/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFDecisionsSummary
 */
export interface CRSFDecisionsSummary {
    /**
     * 
     * @type {string}
     * @memberof CRSFDecisionsSummary
     */
    aggr_sec_analysis_comment?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFDecisionsSummary
     */
    aggr_sec_analysis_report?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CRSFDecisionsSummary
     */
    decisions_json?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CRSFDecisionsSummary
     */
    detailed_url?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFDecisionsSummary
     */
    has_contingencies?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFDecisionsSummary
     */
    has_declines?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFDecisionsSummary
     */
    has_pricing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFDecisionsSummary
     */
    has_relevant_issues?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFDecisionsSummary
     */
    has_warnings?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFDecisionsSummary
     */
    public_aggr_sec_analysis_comment?: string;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof CRSFDecisionsSummary
     */
    warnings?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof CRSFDecisionsSummary
     */
    wiretapping_technologies?: { [key: string]: Array<string>; };
}

/**
 * Check if a given object implements the CRSFDecisionsSummary interface.
 */
export function instanceOfCRSFDecisionsSummary(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFDecisionsSummaryFromJSON(json: any): CRSFDecisionsSummary {
    return CRSFDecisionsSummaryFromJSONTyped(json, false);
}

export function CRSFDecisionsSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFDecisionsSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aggr_sec_analysis_comment': !exists(json, 'aggr_sec_analysis_comment') ? undefined : json['aggr_sec_analysis_comment'],
        'aggr_sec_analysis_report': !exists(json, 'aggr_sec_analysis_report') ? undefined : json['aggr_sec_analysis_report'],
        'decisions_json': !exists(json, 'decisions_json') ? undefined : json['decisions_json'],
        'detailed_url': !exists(json, 'detailed_url') ? undefined : json['detailed_url'],
        'has_contingencies': !exists(json, 'has_contingencies') ? undefined : json['has_contingencies'],
        'has_declines': !exists(json, 'has_declines') ? undefined : json['has_declines'],
        'has_pricing': !exists(json, 'has_pricing') ? undefined : json['has_pricing'],
        'has_relevant_issues': !exists(json, 'has_relevant_issues') ? undefined : json['has_relevant_issues'],
        'has_warnings': !exists(json, 'has_warnings') ? undefined : json['has_warnings'],
        'public_aggr_sec_analysis_comment': !exists(json, 'public_aggr_sec_analysis_comment') ? undefined : json['public_aggr_sec_analysis_comment'],
        'warnings': !exists(json, 'warnings') ? undefined : json['warnings'],
        'wiretapping_technologies': !exists(json, 'wiretapping_technologies') ? undefined : json['wiretapping_technologies'],
    };
}

export function CRSFDecisionsSummaryToJSON(value?: CRSFDecisionsSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aggr_sec_analysis_comment': value.aggr_sec_analysis_comment,
        'aggr_sec_analysis_report': value.aggr_sec_analysis_report,
        'decisions_json': value.decisions_json,
        'detailed_url': value.detailed_url,
        'has_contingencies': value.has_contingencies,
        'has_declines': value.has_declines,
        'has_pricing': value.has_pricing,
        'has_relevant_issues': value.has_relevant_issues,
        'has_warnings': value.has_warnings,
        'public_aggr_sec_analysis_comment': value.public_aggr_sec_analysis_comment,
        'warnings': value.warnings,
        'wiretapping_technologies': value.wiretapping_technologies,
    };
}

